import React, { memo } from 'react';
import PatrimonioCardBase from '../../../../../../components/organisms/EmpresaIndicadores/PatrimonioCard';
import { useEmpresasContext } from '../../../../../../contexts/EmpresasContext';

const PatrimonioCard = memo(() => {
  const { state, actions } = useEmpresasContext();
  const xHistorico = state?.historico?.pl || [];

  return (
    <PatrimonioCardBase
      pessoaId={state?.pessoa?.pessoa_id}
      pessoaNome={state?.pessoa?.pessoa_fantasia || state?.pessoa?.pessoa}
      setorId={state?.pessoa?.setor_id}
      historico={xHistorico}
      isLoading={state?.isPageLoading}
      consolidacaoTipo={state?.config?.consolidacao_tipo}
      onChangeConsolidacao={pValue =>
        actions.handleConfigChange({
          consolidacao_tipo: pValue
        })
      }
      actions={{
        formatNumber: pValue => actions.formatNumber(pValue, state.showPrecise, true, 2, null)
      }}
      onOpenHistory={actions.handleChartVariantChange}
    />
  );
});

PatrimonioCard.displayName = 'PatrimonioCard';

export default PatrimonioCard;
